export const isSelfOnboarding = () => {
  const isOnboardingEnabled = App.config.get('venue').selfOnboardingEnabled;
  const isVenueInOnboarding = App.config.isVenuePending();

  return isOnboardingEnabled && isVenueInOnboarding;
};
